var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMaticxDark = function SvgMaticxDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12Zm-6.858 9.385 4.243-4.243-2.018-2.018a8.028 8.028 0 0 1-4.243 4.243l2.018 2.018Zm-7.709-1.806a8.025 8.025 0 0 1-4.555-3.93l-1.635 1.635 4.242 4.243 1.948-1.948Zm-4.8-10.703a8.028 8.028 0 0 1 4.243-4.243L9.243 5 5 9.243l1.633 1.633Zm11.015-3.997 1.737-1.737 4.242 4.243-2.048 2.048a8.025 8.025 0 0 0-3.93-4.554Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.769 12.695a.67.67 0 0 0-.602 0l-1.403.784-.953.498-1.378.783a.67.67 0 0 1-.602 0l-1.078-.617a.574.574 0 0 1-.3-.498v-1.187c0-.19.1-.38.3-.499l1.078-.593a.67.67 0 0 1 .602 0l1.077.617c.176.095.301.285.301.498v.784l.953-.522v-.808c0-.19-.1-.38-.301-.498l-2.005-1.116a.67.67 0 0 0-.602 0l-2.055 1.14c-.2.095-.301.284-.301.474v2.232c0 .19.1.38.3.498l2.031 1.116a.67.67 0 0 0 .602 0l1.378-.76.953-.522 1.378-.76a.67.67 0 0 1 .602 0l1.078.594c.175.095.3.285.3.499v1.186c0 .19-.1.38-.3.5l-1.053.592a.67.67 0 0 1-.602 0l-1.077-.593a.574.574 0 0 1-.301-.498v-.76l-.953.522v.783c0 .19.1.38.301.5l2.03 1.115a.67.67 0 0 0 .602 0l2.03-1.116a.574.574 0 0 0 .301-.498v-2.256c0-.19-.1-.38-.3-.498l-2.031-1.116Z",
    fill: "#2C2C2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 1.4,
    width: 25.2,
    height: 25.2,
    rx: 12.6,
    stroke: "#2C2C2E",
    strokeWidth: 1.2
  })));
};
export default SvgMaticxDark;